/*
 1_number_info: 號碼類別
 2_activity_track: 活躍軌跡
 3_special_fin: 特殊業者紀錄
 4_debt_collection_all: 催繳 - 所有催繳 (不分類)
 5_debt_collection_finance_inst: 催繳 - 金融機構
 6_debt_collection_finance_second: 催繳 - 二類金融
 7_debt_collection_life: 催繳 - 生活類型
 8_finance: 金融業者紀錄
 9_life: 生活類型紀錄
 10_spam: 騷擾類型紀錄
 11_graph_special_fin: 二階關聯-特殊業者紀錄
 12_graph_debt_collection_all : 二階關聯-所有催繳
 13_graph_debt_collection_life: 二階關聯-催繳-生活類型
 14_graph_finance: 二階關聯-金融業者紀錄
 15_graph_life: 二階關聯-生活類型
*/
export const IDENTITY_REPORT = {
  FACTORS_CATEGORY: {
    credit: {
      info_special_tag: '1_number_info',
      info_special_categ: '1_number_info',
      info_spam_categ: '1_number_info',
      info_yp_categ: '1_number_info',
      info_yp_tag: '1_number_info',
      status_verify_yn: '1_number_info',
      status_has_abnormal_pattern_2_yn_1y: '2_activity_track',
      status_reachable_count_3y: '2_activity_track',
      status_social_node_count: '2_activity_track',
      status_reachable_count_1y: '2_activity_track',
      status_last_call_activity_1st_day_range_3y: '2_activity_track',
      call_compare_w_else_z_score_6m: '2_activity_track',
      status_verify_yn_2: '2_activity_track',
      cluster_fin_high_interest_loans_qc_count_in_6m: '3_special_fin',
      cluster_fin_high_interest_loans_qc_count_out_6m: '3_special_fin',
      cluster_fin_installment_qc_count_in_6m: '3_special_fin',
      cluster_fin_installment_qc_count_out_6m: '3_special_fin',
      cluster_fin_dummy_account_recruitment_qc_count_in_6m: '3_special_fin',
      cluster_fin_dummy_account_recruitment_qc_count_out_6m: '3_special_fin',
      cluster_fin_dummy_account_recruitment_total_count_in_6m: '3_special_fin',
      cluster_fin_special_career_qc_count_in_6m: '3_special_fin',
      cluster_fin_special_career_total_count_out_6m: '3_special_fin',
      cluster_fin_special_career_total_count_in_6m: '3_special_fin',
      cluster_fin_credit_consultants_qc_count_in_6m: '3_special_fin',
      cluster_fin_credit_consultants_qc_count_out_6m: '3_special_fin',
      cluster_fin_credit_consultants_total_count_out_6m: '3_special_fin',
      cluster_fin_credit_consultants_total_count_in_6m: '3_special_fin',
      cluster_fin_high_interest_loans_total_count_out_6m: '3_special_fin',
      cluster_fin_pawn_shop_qc_count_in_6m: '3_special_fin',
      cluster_fin_pawn_shop_qc_count_out_6m: '3_special_fin',
      cluster_fin_installment_qc_count_out_1m: '3_special_fin',
      cluster_fin_installment_qc_count_in_1m: '3_special_fin',
      cluster_fin_pawn_shop_duration_sum_out_6m: '3_special_fin',
      cluster_fin_pawn_shop_total_count_in_6m: '3_special_fin',
      cluster_fin_dummy_account_recruitment_total_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_special_career_qc_count_out_6m: '3_special_fin',
      cluster_fin_credit_consultants_total_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_high_interest_loans_total_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_installment_total_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_pawn_shop_total_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_debt_collection_qc_count_out_6m: '4_debt_collection_all',
      cluster_fin_debt_collection_qc_count_in_6m: '4_debt_collection_all',
      cluster_fin_debt_collection_total_count_out_1m: '4_debt_collection_all',
      cluster_fin_debt_collection_qc_count_in_1m: '4_debt_collection_all',
      cluster_fin_credit_card_debt_collection_qc_count_in_6m: '5_debt_collection_finance_inst',
      cluster_fin_credit_card_debt_collection_total_count_out_6m: '5_debt_collection_finance_inst',
      cluster_fin_credit_card_debt_collection_total_count_in_6m: '5_debt_collection_finance_inst',
      cluster_fin_debt_collection_agency_qc_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_debt_collection_agency_qc_count_out_6m: '6_debt_collection_finance_second',
      cluster_fin_installment_collection_qc_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_installment_collection_qc_count_out_6m: '6_debt_collection_finance_second',
      cluster_fin_car_loan_debt_collection_qc_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_shark_loan_debt_collection_qc_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_car_loan_debt_collection_total_count_out_6m: '6_debt_collection_finance_second',
      cluster_fin_car_loan_debt_collection_total_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_phone_bill_collection_qc_count_out_6m: '7_debt_collection_life',
      cluster_fin_phone_bill_collection_qc_count_in_6m: '7_debt_collection_life',
      cluster_fin_phone_bill_collection_duration_sum_out_6m: '7_debt_collection_life',
      cluster_fin_loans_qc_count_out_6m: '8_finance',
      cluster_fin_third_party_payment_qc_count_out_6m: '8_finance',
      cluster_fin_mortgage_qc_count_out_6m: '8_finance',
      cluster_fin_credit_card_telemarketing_qc_count_out_6m: '8_finance',
      cluster_fin_car_loan_qc_count_out_6m: '9_life',
      cluster_life_legal_consultancy_service_qc_count_in_6m: '9_life',
      cluster_life_legal_consultancy_service_qc_count_out_6m: '9_life',
      cluster_life_job_hunting_qc_count_out_6m: '9_life',
      cluster_life_temp_agencies_qc_count_in_6m: '9_life',
      cluster_life_temp_agencies_qc_count_out_6m: '9_life',
      cluster_life_car_rental_qc_count_in_6m: '9_life',
      cluster_life_prison_qc_count_out_6m: '9_life',
      cluster_life_beetle_nut_shop_qc_count_out_6m: '9_life',
      cluster_spam_telemarketing_qc_count_out_6m: '10_spam',
      cluster_spam_telemarketing_qc_count_in_6m: '10_spam',
      cluster_spam_harassment_qc_count_out_6m: '10_spam',
      cluster_spam_harassment_qc_count_in_6m: '10_spam',
      rank: 'credit_risk',
      cluster_spam_hfb_total_count_in_1m: '10_spam',
      cluster_fin_loan_telemarketing_qc_count_in_6m: '3_special_fin',
      cluster_fin_sms_installment_total_count_out_6m: '3_special_fin',
      cluster_fin_pawn_shop_total_count_out_1m: '3_special_fin',
      cluster_fin_sms_car_loan_total_count_out_6m: '3_special_fin',
      cluster_fin_car_loan_qc_count_in_6m: '3_special_fin',
      cluster_fin_personal_loan_debt_collection_qc_compare_w_else_z_score_in_3m: '8_finance',
      cluster_fin_private_bank_qc_count_out_1m: '3_special_fin',
      cluster_fin_private_bank_qc_count_in_6m: '3_special_fin',
      cluster_fin_loans_qc_compare_w_else_z_score_in_3m: '8_finance',
      cluster_fin_debt_collection_agency_qc_compare_w_else_z_score_in_6m: '3_special_fin',
      cluster_fin_sms_crypto_total_count_in_6m: '3_special_fin',
      call_qc_distinct_caller_in_6m_early_hour: '2_activity_track',
      call_total_distinct_caller_in_1m_early_hour: '2_activity_track',
      call_zero_duration_count_in_1m: '2_activity_track',
      call_zero_duration_distinct_caller_in_1m: '2_activity_track',
      sms_non_contact_count_out_6m: '2_activity_track',
      sms_total_count_out_6m_non_working_hour: '2_activity_track',
      status_consecutive_2d_pattern_max_count_6m: '2_activity_track',
      status_consecutive_2d_pattern_max_avg_count_6m: '2_activity_track',
      cluster_fin_car_loan_duration_sum_in_6m: '3_special_fin',
      cluster_fin_car_loan_total_count_out_6m: '3_special_fin',
      cluster_fin_credit_consultants_duration_sum_out_6m: '3_special_fin',
      cluster_fin_crypto_total_count_out_6m: '3_special_fin',
      cluster_fin_debt_collection_total_count_in_6m: '4_debt_collection_all',
      cluster_fin_debt_collection_total_count_out_6m: '4_debt_collection_all',
      cluster_fin_dummy_account_recruitment_total_count_out_6m: '3_special_fin',
      cluster_fin_fraudloan_nc_count_in_1m: '10_spam',
      cluster_fin_high_interest_loans_total_count_in_6m: '3_special_fin',
      cluster_fin_installment_collection_total_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_installment_duration_sum_in_6m: '6_debt_collection_finance_second',
      cluster_fin_installment_total_count_out_6m: '3_special_fin',
      cluster_fin_loan_telemarketing_total_count_in_6m: '3_special_fin',
      cluster_fin_loan_telemarketing_total_count_out_6m: '3_special_fin',
      cluster_fin_loans_qc_count_in_6m: '8_finance',
      cluster_fin_other_banks_debt_collection_qc_count_in_6m: '8_finance',
      cluster_fin_phone_bill_collection_total_count_in_6m: '7_debt_collection_life',
      cluster_fin_phone_bill_collection_total_count_out_6m: '7_debt_collection_life',
      cluster_fin_private_bank_duration_sum_in_1m: '3_special_fin',
      cluster_fin_private_bank_qc_count_out_6m: '3_special_fin',
      cluster_fin_sms_car_loan_total_count_in_1m: '3_special_fin',
      cluster_fin_sms_credit_consultants_total_count_in_6m: '3_special_fin',
      cluster_fin_sms_debt_collection_total_count_in_6m: '4_debt_collection_all',
      cluster_fin_sms_high_interest_loans_total_count_in_1m: '3_special_fin',
      cluster_fin_sms_high_interest_loans_total_count_out_6m: '3_special_fin',
      cluster_fin_sms_installment_total_count_in_6m: '3_special_fin',
      cluster_fin_sms_installment_total_count_out_1m: '3_special_fin',
      cluster_fin_sms_pawn_shop_total_count_in_6m: '3_special_fin',
      cluster_fin_sms_phone_bill_collection_total_count_in_6m: '7_debt_collection_life',
      cluster_fin_sms_phone_loan_total_count_in_6m: '3_special_fin',
      cluster_fin_spamspecial_with_whoscall_qc_count_in_6m: '10_spam',
      cluster_fin_spamspecial_with_whoscall_qc_count_out_6m: '10_spam',
      cluster_fin_special_is_contact_qc_count_in_6m: '3_special_fin',
      cluster_fin_special_is_contact_qc_count_out_6m: '3_special_fin',
      cluster_fin_gambling_total_count_in_6m: '3_special_fin',
      cluster_fin_gambling_total_count_out_6m: '3_special_fin',
      cluster_life_judicial_court_total_count_in_6m: '9_life',
      cluster_life_judicial_court_total_count_out_6m: '9_life',
      cluster_life_police_qc_count_in_6m: '9_life',
      cluster_life_police_qc_count_out_6m: '9_life',
      cluster_spam_fraud_total_count_in_6m: '10_spam',
      cluster_spam_fraud_total_count_out_6m: '10_spam',
      cluster_spam_harassment_duration_sum_in_1m: '10_spam',
      cluster_spam_harassment_total_count_out_6m: '10_spam',
      cluster_spam_hfb_duration_sum_in_6m: '10_spam',
      cluster_spam_hfb_total_count_out_6m: '10_spam',
      graph_cf_credit_consultants_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_credit_consultants_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_dummy_account_recruitment_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_dummy_account_recruitment_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_high_interest_loans_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_high_interest_loans_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_installment_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_installment_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_pawn_shop_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_pawn_shop_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_debt_collection_duration_all_6m_avg_count_6m: '12_graph_debt_collection_all',
      graph_cf_debt_collection_total_all_6m_avg_count_6m: '12_graph_debt_collection_all',
      graph_cf_phone_bill_collection_duration_all_6m_avg_count_6m: '15_graph_life',
      graph_cf_phone_bill_collection_total_all_6m_avg_count_6m: '13_graph_debt_collection_life',
      graph_cf_crypto_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_crypto_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_car_loan_duration_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_car_loan_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_loan_telemarketing_duration_all_6m_avg_count_6m: '14_graph_finance',
      graph_cf_loan_telemarketing_total_all_6m_avg_count_6m: '11_graph_special_fin',
      graph_cf_credit_consultants_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_credit_consultants_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_dummy_account_recruitment_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_dummy_account_recruitment_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_high_interest_loans_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_high_interest_loans_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_installment_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_installment_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_pawn_shop_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_pawn_shop_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_debt_collection_duration_all_6m_max_count_6m: '12_graph_debt_collection_all',
      graph_cf_debt_collection_total_all_6m_max_count_6m: '12_graph_debt_collection_all',
      graph_cf_phone_bill_collection_duration_all_6m_max_count_6m: '13_graph_debt_collection_life',
      graph_cf_phone_bill_collection_total_all_6m_max_count_6m: '13_graph_debt_collection_life',
      graph_cf_crypto_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_crypto_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_car_loan_duration_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_car_loan_total_all_6m_max_count_6m: '11_graph_special_fin',
      graph_cf_loan_telemarketing_duration_all_6m_max_count_6m: '14_graph_finance',
      graph_cf_loan_telemarketing_total_all_6m_max_count_6m: '14_graph_finance',
      cluster_life_prepaid_card_big3_total_count_all_6m: '9_life',
      cluster_life_prepaid_card_small2_total_count_all_6m: '9_life',
      cluster_life_prepaid_card_others_total_count_all_6m: '9_life',
      cluster_life_sms_prepaid_card_total_count_in_6m: '9_life',
      cluster_fin_sms_credit_consultants_total_count_in_1m: '3_special_fin',
      cluster_fin_sms_insurance_bill_collection_total_count_out_1m: '5_debt_collection_finance_inst',
      cluster_fin_sms_installment_collection_total_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_debt_collection_agency_total_count_in_6m: '6_debt_collection_finance_second',
      cluster_fin_installment_collection_total_compare_w_else_z_score_in_1m: '6_debt_collection_finance_second',
      cluster_fin_shark_loan_debt_collection_qc_compare_w_else_z_score_in_3m: '6_debt_collection_finance_second',
      cluster_fin_credit_card_debt_collection_qc_compare_w_else_z_score_in_6m: '5_debt_collection_finance_inst',
      cluster_fin_personal_loan_debt_collection_qc_compare_w_else_z_score_in_6m: '8_finance',
      cluster_fin_car_loan_debt_collection_qc_compare_w_else_z_score_in_6m: '6_debt_collection_finance_second',
      cluster_fin_credit_union_total_count_in_1m: '8_finance',
      cluster_fin_credit_union_total_count_out_1m: '8_finance',
      cluster_fin_farmers_or_fishery_association_total_count_in_1m: '8_finance',
      cluster_fin_farmers_or_fishery_association_total_count_out_1m: '8_finance',
      cluster_fin_crypto_total_count_out_1m: '3_special_fin',
      cluster_fin_credit_card_telemarketing_total_count_in_1m: '8_finance',
      cluster_fin_loan_telemarketing_total_count_in_1m: '3_special_fin',
      cluster_fin_personal_loan_telemarketing_total_count_in_6m: '8_finance',
      cluster_fin_private_bank_total_count_out_6m: '3_special_fin',
      cluster_fin_pawn_shop_total_count_out_6m: '3_special_fin',
      cluster_fin_installment_total_count_in_6m: '3_special_fin',
      cluster_fin_special_career_qc_compare_w_else_z_score_out_1m: '3_special_fin',
      cluster_fin_special_career_qc_compare_w_else_z_score_in_3m: '3_special_fin',
      cluster_fin_special_is_contact_qc_count_out_1m: '3_special_fin',
      cluster_spam_fraud_total_count_in_1m: '10_spam',
      graph_cl_judicial_court_duration_all_6m_null_rate_6m: '15_graph_life',
      graph_cl_police_qc_all_6m_avg_count_6m: '15_graph_life',
    },
    marketing: {
      cluster_spam_telemarketing_total_count_in_6m: '1_cluster_spam',
      cluster_spam_telemarketing_total_count_out_6m: '1_cluster_spam',
      device_wifi_network_count_6m: '2_device',
      rank: 'credit_risk',
    },
  },
};
